import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('users-icon', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 49 48"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.027 41.118H5.074a.894.894 0 0 1-.885-.948c.117-2.04.543-6.82 2.065-9.023 2.311-3.328 8.941-2.183 11.079-5.16.243-.325.282-1.202.282-1.88a.927.927 0 0 0-.291-.674c-1.834-1.658-3.071-4.562-3.098-7.371C14.172 10.565 15.964 6 21.596 6c5.46 0 7.29 4.516 7.29 9.983 0 2.861-1.242 5.783-3.076 7.45a.941.941 0 0 0-.294.653c-.015.674.027 1.57.258 1.904 2.164 2.977 8.567 1.91 11.019 5.16 1.6 2.154 2.014 6.977 2.122 9.02a.9.9 0 0 1-.888.948z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.045 6.118c2.642.382 5.254 3.73 5.254 8.244 0 2.362-1.038 4.775-2.57 6.152a.774.774 0 0 0-.245.54c-.012.556.023 1.296.216 1.572 1.807 2.458 7.988 1.577 10.036 4.26 1.336 1.779 1.682 5.762 1.772 7.45.02.426 0 1.282-.5 1.782"
  })));
});